import React from 'react';
import Radium from 'radium';
import { string, func, bool } from 'prop-types';
import { AddCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';

import styles from './styles';

const Header = ({ title, onAdd, disabled }) => (
  <div style={styles.header}>
    <UTLabel semibold style={styles.textInputSize}>
      {title}
    </UTLabel>
    {appConfig.userDataManagement.addPhoneButton && (
      <IconButton disabled={disabled} onClick={onAdd} style={!disabled ? styles.addButton : {}}>
        <AddCircle />
      </IconButton>
    )}
  </div>
);

Header.propTypes = {
  title: string.isRequired,
  onAdd: func.isRequired,
  disabled: bool
};

export default Radium(Header);
